import classNames from "classnames";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import { OverlayPanel } from "primereact/overlaypanel";
import { Tooltip } from "primereact/tooltip";
import React, { createRef, useEffect, useRef, useState } from "react";
import { BiBell } from "react-icons/bi";
import { BsStar } from "react-icons/bs";
import { FaBars, FaEllipsisV, FaUser, FaUsers } from "react-icons/fa";
import { GiCog } from "react-icons/gi";
import { IoMdLogOut } from "react-icons/io";
import { SlLocationPin } from "react-icons/sl";
import { TbSunMoon } from "react-icons/tb";
import { NavLink, useNavigate } from "react-router-dom";
import { PopupPesquisa } from "../app/dashboard/topbar/feedback";
import { useInfo } from "../context/infoContext";
import { useTheme } from "../context/themeContext";
import { Api } from "../services/api";
import { handleToggleUser, userInfo } from "../services/authHandlers";
import { DropdownPague, MenuPague } from "../styles/primeReactConfig";
import { getLocal, localClear } from "../utils/localStorageOps";
import { ImagemLogo } from "./imagensDinamicas";

export default function Topbar(props) {
  const menuRef = createRef()
  const mobileRef = createRef()
  const mobileAdminRef = createRef()
  const notificationRef = useRef(null)
  //const [rerender, setRerender] = useState(false)

  const navigate = useNavigate();
  const { itemsTheme } = useTheme()
  const { topbarInfo, setShowPopup, missingBank } = useInfo()
  const [notificacoes, setNotificacoes] = useState([])
  const [reloadNotificacoes, setReloadNotificacoes] = useState(false)
  const [naoLidas, setNaoLidas] = useState(0)


  const [username, setUsername] = useState("")
  function logout() {
    localClear();
    navigate('/');
  }
  function toggleMenu(e) {
    if (!menuRef.current) {
    } else menuRef.current.toggle(e);
  }

  function toggleMobileMenu(e) {
    if (topbarInfo.providers_lista && topbarInfo.providers_lista.length > 0) {
      if (!mobileRef.current) {
      } else mobileRef.current.hide(e);

      if (!mobileAdminRef.current) {
      } else mobileAdminRef.current.toggle(e);
    }
    else {
      if (!mobileRef.current) {
      } else mobileRef.current.toggle(e);
    }
  }

  function toggleNotificationMenu(e) {
    if (!notificationRef.current) {
    } else notificationRef.current.toggle(e);
  }

  function preventMenuClose(event) {
    event.stopPropagation();
  }

  const mobileItems = [
    {
      label: "Configurações",
      icon: <GiCog className="mr-2 text-xl" >
      </GiCog>,
      value: "config",
      command: () => navigate('/dashboard/configuracoes')
    },
    {
      label: "Feedback",
      icon: <BsStar className="mr-2 text-xl" />,
      value: "feed",
      command: () => setShowPopup(true)
    },
    {
      label: "Endereco",
      icon: <SlLocationPin className="mr-2 text-xl" />,
      value: "endereco",
      command: () => navigate('/dashboard/endereco')
    },
    {
      label: "Perfil",
      icon: <FaUser className="mr-2 text-xl" />,
      value: "perfil",
      command: () => navigate('/dashboard/perfil')
    },
    {
      label: "Sair",
      icon: <IoMdLogOut className="mr-2 text-xl" />,
      value: "sair",
      command: () => logout()
    },
  ]

  const mobileItemsAdmin = [
    {
      label: "Configurações",
      icon: <GiCog className="mr-2 text-xl" >
      </GiCog>,
      value: "config",
      command: () => navigate('/dashboard/configuracoes')
    },
    {
      template: <div
        className='w-full flex items-center lg:hidden'
        onClick={preventMenuClose}
        onMouseDown={preventMenuClose}
        onTouchStart={preventMenuClose}
      >
        <Dropdown
          pt={DropdownPague}
          filter
          filterInputAutoFocus={false}
          filterInputProps={{
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: false
          }}
          focusOnHover={false}
          filterBy="alt, label"
          placeholder='Selecione um credor...'
          dropdownIcon={<FaUsers />}
          options={topbarInfo.providers_lista}
          value={userInfo.usuario_id}
          onChange={event => {
            handleToggleUser(event.target.value)
            mobileAdminRef.current?.hide()
          }}
        />
      </div>
    },
    {
      label: "Feedback",
      icon: <BsStar className="mr-2 text-xl" />,
      value: "feed",
      command: () => setShowPopup(true)
    },
    {
      label: "Endereco",
      icon: <SlLocationPin className="mr-2 text-xl" />,
      value: "endereco",
      command: () => navigate('/dashboard/endereco')
    },
    {
      label: "Perfil",
      icon: <FaUser className="mr-2 text-xl" />,
      value: "perfil",
      command: () => navigate('/dashboard/perfil')
    },
    {
      label: "Sair",
      icon: <IoMdLogOut className="mr-2 text-xl" />,
      value: "sair",
      command: () => logout()
    },
  ]

  const marcarLida = async (notificacoes) => {
    try {
      notificationRef.current.hide()
      await Api.post('notificacoes_credor/marcar_lida', { notificacoes })
      setReloadNotificacoes(prevState => !prevState)
    } catch (error) {
      console.log(error)
    }
  }

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((item, index) => {
      return templateNotificacao(item, index);
    });

    return <div className="grid grid-nogutter p-0">{list}</div>;
  };

  function templateNotificacao(item, _index) {
    let titulo = ''
    switch (item.notificacao_tipo) {
      case 'negociacao':
        titulo = 'Nova Negociação'
        break;
      case 'proposta':
        titulo = 'Nova Proposta'
        break;
      default:
        titulo = ''
        break;
    }
    return (<div className={classNames("max-h-18 grid cursor-pointer",
      "dark:hover:bg-slate-700 hover:bg-slate-300 p-2",
      { "font-bold": !item.notificacao_lida }
    )}
      onClick={() => {
        navigate('/dashboard/' + item.notificacao_rota);
        marcarLida([item.notificacao_id]);
      }}
    >
      <h3 className="text-md">{titulo}</h3>
      <p className="text-ellipsis overflow-hidden text-xs">{item.notificacao_descricao}</p>
    </div>)
  }

  useEffect(() => {
    setUsername(getLocal("username"));
  }, [])

  useEffect(() => {
    const teste = async () => {
      if (topbarInfo.providers_lista && topbarInfo.providers_lista.length > 0) {
      }
    }
    teste()
  }, [])


  useEffect(() => {
    const carregaNotificacoes = async () => {
      const user_id = userInfo.usuario_id
      try {
        const { data } = await Api.get(`notificacoes_credor/listar/${user_id}`)
        setNotificacoes(data.rows);
        setNaoLidas(data.nao_lidas || 0)
      } catch (error) {
        // console.log(error.response)
        setNotificacoes([]);
      }
    }
    carregaNotificacoes()
  }, [reloadNotificacoes])


  return (
    <div className="w-screen h-20 fixed dark:bg-card_dark bg-card flex 
    justify-between z-[101] shadow-md shadow-gray-500 dark:shadow-sky-950">
      <div className="lg:w-fit w-full flex flex-col justify-center pl-8 lg:pr-0 pr-8">
        <div className="lg:w-fit w-full flex lg:flex-row flex-row-reverse lg:justify-start justify-between">
          <div className="lg:hidden flex justify-end">
            <div className="flex flex-col justify-center rounded-full w-14 h-14
            hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100"
            >
              <span className="rounded-full flex justify-center"
                onClick={toggleMobileMenu}>
                <FaEllipsisV className="text-card dark:text-card_dark text-[2.2rem]" />
              </span>
            </div>
          </div>
          <div className="lg:w-full  flex justify-center">
            <ImagemLogo />
          </div>
          <div className="flex flex-row">
            <div className="flex flex-col justify-center rounded-full 
              w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
              cursor-pointer duration-100"
            >
              <span className="rounded-full flex justify-center"
                onClick={props.toggleSidebar}>
                <FaBars className="text-card dark:text-card_dark text-[2.2rem]" />
              </span>
            </div>
            <div className="flex items-center justify-center ml-2">
              <Button
                pt={{
                  root: classNames(
                    "rounded-full bg-black text-white ",
                    "dark:text-black dark:bg-white",
                    "flex items-center justify-center w-6 h-6",
                  ),
                  label: "absolute"
                }}
                onClick={toggleMenu}
                icon={<TbSunMoon />}
              />
            </div>
          </div>

          <PopupPesquisa />
        </div>
      </div>
      <div className="md:max-w-[50vw] hidden lg:flex flex-col justify-center ">
        <div className="flex justify-end">
          <div className="flex gap-3 items-center">
            <div className="flex-col justify-center rounded-full 
            w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100 flex"
              onClick={toggleNotificationMenu}>
              <Tooltip target=".notificacoes" content='Notificações' position='bottom'></Tooltip>
              <span className="w-14 h-14 rounded-full flex justify-center notificacoes">
                {notificacoes && naoLidas > 0 &&
                  <Badge
                    pt={{
                      root: ({ props }) => ({
                        className: classNames(
                          'rounded-full p-0 justify-center inline-block ',
                          'bg-blue-500 text-white font-bold',
                          'flex relative z-50 top-[8px] text-xs left-2 w-[18px] h-[18px]',
                          {
                            'bg-gray-500 ': props.severity === 'secondary',
                            'bg-green-500 ': props.severity === 'success',
                            'bg-blue-500 ': props.severity === 'info',
                            'bg-orange-500 ': props.severity === 'warning',
                            'bg-purple-500 ': props.severity === 'help',
                            'bg-red-500 ': props.severity === 'danger'
                          },
                        )
                      })
                    }}
                    severity="danger"
                    value={naoLidas}
                  ></Badge>
                }
                <BiBell className={classNames("text-card dark:text-card_dark text-[2.2rem]",
                  {
                    "top-[11px] -left-2 relative": naoLidas > 0,
                    "top-[11px] left-0 relative": naoLidas === 0,
                  },
                )} >
                </BiBell>
              </span>
            </div>
            <OverlayPanel
              ref={notificationRef}
              closeOnEscape
              dismissable
            >
              <div className="grid max-w-[25rem]">
                {notificacoes.length > 0 ? <DataView
                  value={notificacoes}
                  paginator
                  alwaysShowPaginator={false}
                  rows={5}
                  //lazy
                  listTemplate={listTemplate}
                >
                </DataView> : 
                <h3>Nenhuma notificação recebida</h3>
                }
              </div>
            </OverlayPanel>
            <NavLink to='/dashboard/configuracoes' className="flex-col flex justify-center rounded-full 
            w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100">
              <Tooltip target=".configuracoes" content='Configuracoes' position='bottom'></Tooltip>
              <span className="w-14 h-14 rounded-full flex justify-center configuracoes">
                {missingBank &&
                  <Badge
                    style={{ minWidth: '18px', minHeight: '18px', maxHeight: "18px" }}
                    className='flex relative z-50 top-[8px] left-2'
                    severity="danger"
                  ></Badge>
                }
                <GiCog className={classNames("text-card dark:text-card_dark text-[2.2rem]",
                  {
                    "top-[11px] -left-2 relative": missingBank,
                    "top-[11px] left-0 relative": !missingBank,
                  },
                )} >
                </GiCog>
              </span>
            </NavLink>
            <div onClick={() => setShowPopup(prevState => !prevState)} className="flex-col flex justify-center rounded-full 
            w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100">
              <Tooltip target=".feedback" content='Feedback' position='bottom'></Tooltip>
              <span className=" rounded-full flex justify-center feedback h-full w-full items-center">
                <BsStar className="text-card dark:text-card_dark text-[2.2rem]" />
              </span>
            </div>
            <NavLink to='/dashboard/endereco' className="flex-col flex justify-center rounded-full 
            w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100">
              <Tooltip target=".endereco" content='Endereco' position='bottom'></Tooltip>
              <span className=" rounded-full flex justify-center endereco h-full w-full items-center">
                <SlLocationPin className="text-card dark:text-card_dark text-[2rem]" />
              </span>
            </NavLink>
            <span className="flex-col flex justify-center rounded-full 
            w-14 h-14 hover:bg-slate-300 dark:hover:bg-sky-900 
            cursor-pointer duration-100"
              onClick={() => logout()}
            >
              <Tooltip target=".logout" content='Logout' position='bottom'></Tooltip>
              <span className=" rounded-full flex justify-center logout h-full w-full items-center">
                <IoMdLogOut className="text-card dark:text-card_dark text-[2.2rem]" />
              </span>
            </span>
          </div>
          {topbarInfo.providers_lista && topbarInfo.providers_lista.length > 0 &&
            <div className='flex items-center p-1'>
              <Tooltip target=".credor" content='Credor' position='bottom' />
              <Dropdown
                className='md:max-w-[25vw] credor'
                pt={DropdownPague}
                filter
                filterInputAutoFocus
                //autoFocus
                focusOnHover={false}
                filterBy="alt, label"
                placeholder='Selecione um credor...'
                dropdownIcon={<FaUsers />}
                options={topbarInfo.providers_lista}
                value={userInfo.usuario_id}
                onChange={event => {
                  handleToggleUser(event.target.value)
                }}
              />
            </div>
          }
          {/* </div> */}
          <div className="h-full w-auto p-1 px-6">
            <NavLink to='/dashboard/perfil'>
              <div className=" dark:bg-pague_amarelo bg-pague_verde
            h-full text-card_dark dark:text-card
            rounded-md text-lg items-center flex px-4 cursor-pointer
            hover:bg-pague_verde_claro duration-100
            font-medium gap-2 whitespace-nowrap md:max-w-[15vw]"
                onClick={() => navigate('/perfil')}
              >
                <FaUser className="min-w-4" />
                <label className="text-ellipsis overflow-hidden cursor-pointer">{username}</label>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
      <Menu
        popup
        ref={menuRef}
        model={itemsTheme}
        pt={MenuPague}
      />
      <Menu
        popup
        ref={mobileRef}
        model={mobileItems}
        pt={MenuPague}
      />
      <Menu
        popup
        ref={mobileAdminRef}
        model={mobileItemsAdmin}
        pt={MenuPague}
      />
    </div>
  );
}
